import { render } from "./Account.vue?vue&type=template&id=7b4be964&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7b4be964"

export default script